import React, { useContext } from "react";

type PaywallState = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

export const PaywallContext = React.createContext<PaywallState>({
  isOpen: false,
  setIsOpen: () => {},
});

export const usePaywall = () => {
  const { isOpen, setIsOpen } = useContext(PaywallContext);

  const showPaywall = () => {
    setIsOpen(true);
  };

  const hidePaywall = () => {
    setIsOpen(false);
  };

  const togglePaywall = () => {
    setIsOpen(!isOpen);
  };

  return { isOpen, setIsOpen, showPaywall, hidePaywall, togglePaywall };
};
